// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"loginModal_mulitpleDropdown__WUYqN","modalWrapper":"loginModal_modalWrapper__1tsg_","loginFormWrapper":"loginModal_loginFormWrapper__1FwS6"};